module.exports = __webpack_public_path__ + "img/login_bg_img.de013fe9.jpeg";